export type LabelMetaData = {
	[k: string]: MetaData;
};

export interface MetaData {
	label?: string;
	description?: string;
	visible?: boolean;
	type?: string;
	key?: string;
	field_name?: string;
	align?: 'left' | 'center' | 'right';
	format?: any;
	currency?: string;
	isPercentage?: boolean;
	numberOfDecimal?: number;
	nullValue?: any;
	number1?: number;
	number2?: number;
	number3?: number;
	isMissingValueEmpty?: boolean;
	isVirtualField?: boolean;
	expression?: string[];
	mapType?: MapType;
}

export enum MapType {
	PROVINCE_OF_TURKEY = 'province-of-turkey',
	WORLD_COUNTRY = 'world-country',
}
